import React, { useEffect } from "react";
import { useDispatch } from "react-redux";
import { UPDATE_OIB } from "../../constants/constants";

const RedirectTest = ({ history, location, match }) => {
  const dispatch = useDispatch();

  useEffect(() => {
    const { personOib, forLegalIps } = match.params;

    if (!personOib && !forLegalIps) {
      history.push("/");
      return;
    }

    window.sessionStorage.clear();

    const action = {
      type: UPDATE_OIB,
      payload: personOib === "null" ? forLegalIps : personOib,
      subjectData: {
        personOib,
        forLegalIps,
        ...match.params,
      },
    };

    dispatch(action);
    history.push("/");
  }, []);

  return <div></div>;
};

export default RedirectTest;
